/**
 * Registers a single global Axios request interceptor that stamps the
 * `X-Origin-Page` header on every outbound request.
 *
 * The whole app uses the default `axios` instance directly, so this one
 * interceptor covers every API call with no per-call-site changes.
 *
 * Call `setupOriginInterceptor()` once at app startup (see src/index.js),
 * before any requests are made.
 */
import axios from "axios";
import { buildXOrigin } from "./originContext";

// The single origin header. Carries the full "page|modal" value.
export const X_ORIGIN_HEADER = "X-Origin-Page";

// Remember the registered interceptor id so repeated calls (e.g. hot reload in
// dev) don't stack duplicate interceptors.
let interceptorId = null;

export const setupOriginInterceptor = () => {
  if (interceptorId !== null) return interceptorId;

  interceptorId = axios.interceptors.request.use((config) => {
    try {
      const origin = buildXOrigin();
      if (origin) {
        // config.headers is normally present; guard for safety.
        if (!config.headers) config.headers = {};
        config.headers[X_ORIGIN_HEADER] = origin;
      }
    } catch (e) {
      // Origin metadata is best-effort: never let it block a request.
    }
    return config;
  });

  return interceptorId;
};

export default setupOriginInterceptor;
